/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
import log from "cslog";

import { default as AudioPlayerLib, RHAP_UI } from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function AudioPlayer({ id, db, device, gs }) {
    const data = db[id];

    log.d(data, "Data in AP");

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    //=========================
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);
    const styleTab = tablet(device) ? decodeStyle(ps.tablet, gs) : {};
    const styleMob = mobile(device) ? decodeStyle(ps.mobile, gs) : {};

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const audioSrc = input?.audioFile?.value;
    log.d(audioSrc, "AudioSRC");

    const color = input.themeColor || "purple";
    const timeColor = input.timeTextColor || "black";
    const barColor = input.barColor || "cyan";

    return (
        <div>
            {" "}
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    ...decodeStyle(ps.style, gs),
                }}
                css={css`
                    .rhap_progress-indicator,
                    .rhap_volume-filled,
                    .rhap_volume-indicator,
                    .rhap_progress-filled {
                        background: ${color};
                    }
                    .rhap_progress-bar-show-download {
                        background-color: rgba(${barColor}, 0.5);
                    }
                    .rhap_repeat-button,
                    .rhap_main-controls-button,
                    .rhap_volume-button {
                        color: ${color};
                    }
                    .rhap_time {
                        color: ${timeColor};
                    }
                    .rhap_volume-bar,
                    .rhap_progress-bar,
                    .rhap_download-progress {
                        background: ${barColor};
                    }
                    .rhap_progress-bar-show-download {
                        background-color: rgba(${barColor}, 0.5);
                    }
                `}
            >
                <AudioPlayerLib
                    src={audioSrc}
                    autoPlay={input.autoPlay}
                    loop={input.loop}
                    layout={
                        input.showProgressBelow ? "stacked-reverse" : "stacked"
                    }
                    showJumpControls={input.showJumpControls}
                    customVolumeControls={
                        input.showVolumeControls ? [RHAP_UI.VOLUME] : []
                    }
                    customAdditionalControls={
                        input.showLoopButton ? [RHAP_UI.LOOP] : []
                    }
                    customProgressBarSection={
                        input.showProgressbar
                            ? [
                                  RHAP_UI.CURRENT_TIME,
                                  RHAP_UI.PROGRESS_BAR,
                                  RHAP_UI.DURATION,
                              ]
                            : []
                    }
                    style={{
                        backgroundColor: "transparent",
                    }}
                />
            </div>
        </div>
    );
}

export default AudioPlayer;
